import { SKIN } from '../../settings';
import { getHex, getInt } from '@/utils/common';
import type { IAvatarOptionsProps } from '../../types';
import ColorPanel from '@/components/AvatarOptionsPanel/ColorPanel';

export const SkinAvatar: React.FC<IAvatarOptionsProps<number>> = ({
  name,
  label,
  option,
  setOption,
}) => {
  const handleSetOption = (value: string) => setOption(name, getInt(value));
  const currentColor = getHex(option as number);

  return (
    <ColorPanel
      setColor={handleSetOption}
      color={currentColor}
      palettes={SKIN}
      label={label}
    />
  );
};
